export default __webpack_public_path__ + "static/media/gwlessons_overlay.40d0e4a3.png";